import OffCanvas from './offcanvas';

export default class Navigation {
	constructor(root) {
		this.root = root;
		this.lastScroll = scrollY;

		this.offCanvasEl = root.querySelector('.off-canvas');
		this.offCanvasMenuLinks = this.offCanvasEl.querySelectorAll('.mobile-menu .menu-item > a');
		this.offCanvasSubmenus = this.offCanvasEl.querySelectorAll('.mobile-menu .menu-item .sub-menu-outer');

		const offCanvas = new OffCanvas(this.offCanvasEl);

		this.offCanvasEl.querySelectorAll('a, button').forEach((el) => {
			el.setAttribute('tabindex', '-1');
		});

		offCanvas.onOpen(() => {
			this.offCanvasEl.querySelectorAll('a, button').forEach((el) => {
				el.setAttribute('tabindex', '0');
			});
		});

		offCanvas.onClose(() => {
			this.offCanvasEl.querySelectorAll('a, button').forEach((el) => {
				el.setAttribute('tabindex', '-1');
			});
		});

		this.offCanvasMenuLinks?.forEach((link) => {
			link?.addEventListener('click', (e) => {
				const subMenu = link.parentElement.querySelector('.sub-menu-outer');

				if (subMenu) {
					e.preventDefault();
					this.openSubMenu(link);
				}
			});
		});

		// Extend submenu's with back link and parent link; wrap in a single <ul> so all <li> have role="list" parent (WCAG).
		this.offCanvasSubmenus?.forEach((menu) => {
			const _parentLink = menu.parentElement.querySelector('a');
			const subMenuList = menu.querySelector('ul.sub-menu');

			const parentLink = _parentLink.parentElement.cloneNode(true);
			parentLink.querySelector('.sub-menu')?.remove();
			parentLink.classList.remove('top-level');
			parentLink.classList.add('parent-link');
			parentLink.setAttribute('role', 'listitem');

			const backLink = document.createElement('button');
			backLink.setAttribute('type', 'button');
			backLink.setAttribute('class', 'btn back fluid primary');
			backLink.setAttribute('tabindex', '-1');
			backLink.setAttribute('aria-label', 'Terug');
			backLink.addEventListener('click', () => this.closeSubMenu(_parentLink));
			backLink.textContent = 'Terug';

			const wrapperUl = document.createElement('ul');
			wrapperUl.setAttribute('role', 'list');
			wrapperUl.setAttribute('class', 'sub-menu-outer__list list-none flex flex-col gap-5 flex-1 min-h-0');

			const liBack = document.createElement('li');
			liBack.setAttribute('role', 'listitem');
			liBack.appendChild(backLink);
			wrapperUl.appendChild(liBack);

			wrapperUl.appendChild(parentLink);

			const liSub = document.createElement('li');
			liSub.setAttribute('role', 'listitem');
			if (subMenuList) {
				subMenuList.remove();
				liSub.appendChild(subMenuList);
			}
			wrapperUl.appendChild(liSub);

			while (menu.firstChild) {
				menu.removeChild(menu.firstChild);
			}
			menu.appendChild(wrapperUl);

			this.removeSubMenuTabIndexes(menu);
		});

		document.addEventListener('scroll', () => this.onScroll());
	}

	onScroll(e) {
		if (scrollY > 100) {
			this.collapse();

			if (scrollY > this.lastScroll) {
				document.body.classList.remove('scrolling-up');
				document.body.classList.add('scrolling-down');
			} else {
				document.body.classList.remove('scrolling-down');
				document.body.classList.add('scrolling-up');
			}
		} else {
			this.expand();
		}
		this.lastScroll = scrollY;
	}

	collapse() {
		this.root?.classList.add('collapsed');
	}

	expand() {
		this.root?.classList.remove('collapsed');
	}

	addSubMenuTabIndexes(subMenu) {
		subMenu?.querySelectorAll('a').forEach((link) => {
			link.setAttribute('tabindex', '0');
		});
	}

	removeSubMenuTabIndexes(subMenu) {
		subMenu?.querySelectorAll('a').forEach((link) => {
			link.setAttribute('tabindex', '-1');
		});
	}

	openSubMenu(link) {
		const subMenu = link?.parentElement?.querySelector('.sub-menu-outer');
		this.addSubMenuTabIndexes(subMenu);

		subMenu?.classList.add('active');
	}

	closeSubMenu(link) {
		const subMenu = link?.parentElement?.querySelector('.sub-menu-outer');
		this.removeSubMenuTabIndexes(subMenu);

		subMenu?.classList.remove('active');
	}
}
